import React from 'react';
import { TotalEntries } from '../../components';
import { ContentSegmentOption } from './ContentSegmentsContext';
import { useQueryParams } from '../../queryParams/useQueryParams';

export interface ContentSegmentTotalEntriesProps<
  Segment extends string = string
> {
  segments: ContentSegmentOption<Segment>[];
}

export const ContentSegmentTotalEntries = <Segment extends string = string>(
  props: ContentSegmentTotalEntriesProps<Segment>
) => {
  const { segments } = props;
  const [queryParams] = useQueryParams();
  const currentSegment = queryParams.segment || segments[0].value;
  const segment = segments.find((item) => item.value === currentSegment);
  return <TotalEntries count={segment?.count} />;
};
